import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import TableOfContents from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blob/components/table_contents.vue?vue3';

export default function initTableOfContentsApp() {
  const tableContentsEl = document.querySelector('.js-table-contents');
  if (!tableContentsEl) return null;

  return initVueApp({
    el: tableContentsEl,
    name: 'BlobTableOfContentsRoot',
    component: TableOfContents,
  });
}
